import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { Toast } from "primereact/toast";
import Loader from "../../../../Base/Components/Loader/Loader";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "../../../../Base/Hooks/useForm";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { EditarConcepto, getCuentasHijas, GuardarConcepto, traducir } from "../../../../API/Finanzas/Retencion/ConceptoRetencionRequest";
import { toastShow } from "../../../../Base/Services/ToastService";

const ConceptoRetencionCrud = ({
  showDialog,
  selected,
  setSelected,
  setShowDialog,
  getInfo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const esAdmin = userAuth?.IdRol === 1;

  const [loading, setLoading] = useState(false);
  const [cuentas, setCuentas] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");

  const initialValues = {
    IdConceptoRetencion: -1,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const cuentasTempo = await getCuentasHijas();

    let cuentaInicial;
    if (selected?.IdConceptoRetencion) {
      setDialogTitle("Editar Concepto");
      cuentaInicial = cuentasTempo.find((e) => e.IdAccount === selected?.IdCuenta);
    } else {
      setDialogTitle("Agregar Concepto");
    }
    setCuentas(cuentasTempo);

    setValues({
      ...selected,
      IdCuenta: cuentaInicial?.IdAccount,
      NombreCuenta: cuentaInicial,
    });
    setLoading(false);
  };

  //Traducir ingles texto
  const handleChange = async (e) => {
    const { name, value } = e.target;
    handleInputChange(e);

    if (name === "ContenidoArticuloES") {
      const traduccion = await traducir(value);
      setValues((prev) => ({
        ...prev,
        ContenidoArticuloEN: traduccion,
      }));
    }
  };

  const verificarInfo = () => {
    let error = {};
    if (!values?.CodigoRetencion) {
      error.CodigoRetencion = true;
      error.error = true;
    }
    if (!values?.Tasa) {
        error.Tasa = true;
        error.error = true;
    }
    if (!values?.ContenidoArticuloES) {
        error.ContenidoArticuloES = true;
        error.error = true;
    }
    if (!values?.ContenidoArticuloEN) {
        error.ContenidoArticuloEN = true;
        error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if (e.error) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Completar los campos requeridos."
      );
      return;
    }

    if (!e?.error) {
      const Datos = {
        IdConceptoRetencion: values?.IdConceptoRetencion ? values?.IdConceptoRetencion : -1,
        CodigoRetencion: values?.CodigoRetencion,
        DescripcionImpuestoRetenido: values?.DescripcionImpuestoRetenido,
        Tasa: values?.Tasa,
        IdCuenta: values?.NombreCuenta?.IdAccount || values?.IdCuenta,
        ContenidoArticuloES: values?.ContenidoArticuloES,
        ContenidoArticuloEN: values?.ContenidoArticuloEN
      };

      setLoading(true);
      if (Datos?.IdConceptoRetencion > 0) {
        const respuesta = await EditarConcepto(Datos);
          toastShow(toast, "success", "Editado", "Concepto editado correctamente.");
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
      } else {
        const respuesta = await GuardarConcepto(Datos);
            toastShow(toast, "success", "Editado", "Concepto agregado correctamente.");
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setSelected(null);
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);
  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100%", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h4 className="mx-4">{dialogTitle}</h4>
            </div>
            <Toast ref={toast} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputText
                    keyfilter="int"
                    name="CodigoRetencion"
                    value={values?.CodigoRetencion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.CodigoRetencion ? "p-invalid" : ""}
                  />
                  <label htmlFor="CodigoRetencion">Código Concepto</label>
                </span>
              </div>

              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputText
                    keyfilter="pnum"
                    name="Tasa"
                    value={values?.Tasa}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Tasa ? "p-invalid" : ""}
                  />
                  <label htmlFor="Tasa">Tasa %</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="DescripcionImpuestoRetenido"
                    value={values?.DescripcionImpuestoRetenido}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={
                      error.DescripcionImpuestoRetenido ? "p-invalid" : ""
                    }
                  />
                  <label htmlFor="DescripcionImpuestoRetenido">
                    Descripcion del Impuesto
                  </label>
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"NombreCuenta"}
                    value={values?.NombreCuenta}
                    items={cuentas}
                    field={"NombreCuenta"}
                    label={"Cuenta"}
                    handleInputChange={handleInputChange}
                    className={error.IdTipoRango ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="ContenidoArticuloES"
                    value={values?.ContenidoArticuloES}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.ContenidoArticuloES ? "p-invalid" : ""}
                    rows={15}
                  />
                  <label htmlFor="ContenidoArticuloES">Artículo Español</label>
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="ContenidoArticuloEN"
                    value={values?.ContenidoArticuloEN}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.ContenidoArticuloEN ? "p-invalid" : ""}
                    rows={15}
                  />
                  <label htmlFor="ContenidoArticuloEN">Artículo Ingles</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ConceptoRetencionCrud;
